import React from 'react';
import { Progress } from '@trip-ux/components';
import { ReduxStore } from '@trip-ux/redux-store';
import { useSelector } from 'react-redux';

export default () => {
  const { locale, clientContextPath } = useSelector((store: ReduxStore) => ({
    locale: store.config?.locale,
    clientContextPath: store.config?.options?.clientContextPath
  }));

  const basePath = clientContextPath?.[locale] ?? '';
  window.history.pushState({}, '', `${basePath}/notfound`);
  return <Progress backdrop />;
};
